import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../Core/Store/store';

//initial state for spinner info
const initialState: { spin: boolean } = {
  spin: true,
};

/**
 * @todo
 * create my reducer && set actions to it
 *
 */
export const spinnerSlice = createSlice({
  name: 'spinner',
  initialState,

  reducers: {
    //to show spinner or close it
    setLoading: (state, action) => {
      state.spin = action.payload;
    },
  },
});

// export my actions to dispatch hook
export const { setLoading } = spinnerSlice.actions;

// get my spinner object from my selector hook
export const selectLoading = (state: RootState) => state.spinner.spin;

// export reducer to my state
export default spinnerSlice.reducer;
